<template>
  <div>
    <input
      id="template_name"
      type="text"
      v-model="item.name"
      class="border-steel-gray rounded h-8 w-full"
    />
  </div>
</template>

<script>
export default {
  name: "AddEditDebriefTemplate",
  props: {
    modelValue: { type: Object, required: true },
  },
  computed: {
    item: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
};
</script>

<style scoped></style>
